import { starredContent, isPatientStory } from 'base/my-content';
export var isChapterStarred = {};
export var activeChapterURL = "";
export const chapterID = [
    '#pre-surgery',
    '#surgery',
    '#hospital',
    '#at-home',
    '#laryngectomy-life',
];
export function generateIsChapterStarred() {
    for (const key of chapterID) {
        console.log('checking key', key);
        let check = window.location.pathname + key;
        if (starredContent.pages.indexOf(check) !== -1)
            isChapterStarred[key] = true;
    }
}
(function ($) {
    $(document).on('ready', function () {
        if (!isPatientStory)
            return;
        var scroll = $(window).scrollTop();
        var offset = 360;
        var previousChapter = '';
        console.log('starredContent', starredContent);
        generateIsChapterStarred();
        console.log('isChapterStarred', isChapterStarred);
        var lastChapterNumber = chapterID.length - 1;
        let currentPageURL = window.location.pathname;
        var elementExists = document.getElementById(chapterID[0].substring(1));
        if (elementExists != null) {
            $('.wm-chapterOptionBox .wm-savedContentOpenPopup').attr('data-path', currentPageURL);
            scroll = $(window).scrollTop();
            if (scroll < $(chapterID[0]).offset().top - offset) {
                if (previousChapter != '') {
                    $('a.wm-storyMenu__chapterLink[href=' + previousChapter + ']').removeClass('-activeChapter');
                    $('a.wm-storyMenuMobile__chapterLink[href=' + previousChapter + ']').removeClass('-activeChapter');
                }
            }
            else {
                for (let i = 0; i < chapterID.length; i++) {
                    if ((i == lastChapterNumber && scroll >= $(chapterID[lastChapterNumber]).offset().top - offset) ||
                        (scroll >= $(chapterID[i]).offset().top - offset && scroll < $(chapterID[i + 1]).offset().top - offset)) {
                        if (previousChapter != '') {
                            $('a.wm-storyMenu__chapterLink[href=' + previousChapter + ']').removeClass('-activeChapter');
                            $('a.wm-storyMenuMobile__chapterLink[href=' + previousChapter + ']').removeClass('-activeChapter');
                        }
                        $('a.wm-storyMenu__chapterLink[href=' + chapterID[i] + ']').addClass('-activeChapter');
                        $('a.wm-storyMenuMobile__chapterLink[href=' + chapterID[i] + ']').addClass('-activeChapter');
                        activeChapterURL = currentPageURL + chapterID[i];
                        $('.wm-chapterOptionBox .wm-savedContentOpenPopup').attr('data-path', activeChapterURL);
                        previousChapter = chapterID[i];
                        break;
                    }
                }
            }
            $(window).on('scroll', function () {
                scroll = $(window).scrollTop();
                if (scroll < $(chapterID[0]).offset().top - offset) {
                    if (previousChapter != '') {
                        $('a.wm-storyMenu__chapterLink[href=' + previousChapter + ']').removeClass('-activeChapter');
                        $('a.wm-storyMenuMobile__chapterLink[href=' + previousChapter + ']').removeClass('-activeChapter');
                    }
                }
                else {
                    for (let i = 0; i < chapterID.length; i++) {
                        if ((i == lastChapterNumber && scroll >= $(chapterID[lastChapterNumber]).offset().top - offset) ||
                            (scroll >= $(chapterID[i]).offset().top - offset && scroll < $(chapterID[i + 1]).offset().top - offset)) {
                            if (previousChapter != '') {
                                $('a.wm-storyMenu__chapterLink[href=' + previousChapter + ']').removeClass('-activeChapter');
                                $('a.wm-storyMenuMobile__chapterLink[href=' + previousChapter + ']').removeClass('-activeChapter');
                            }
                            $('a.wm-storyMenu__chapterLink[href=' + chapterID[i] + ']').addClass('-activeChapter');
                            $('a.wm-storyMenuMobile__chapterLink[href=' + chapterID[i] + ']').addClass('-activeChapter');
                            activeChapterURL = currentPageURL + chapterID[i];
                            $('.wm-chapterOptionBox .wm-savedContentOpenPopup').attr('data-path', activeChapterURL);
                            previousChapter = chapterID[i];
                            if (isChapterStarred[chapterID[i]] == true)
                                $('.-addToFavorites i').addClass('font-weight-bold');
                            else
                                $('.-addToFavorites i').removeClass('font-weight-bold');
                            break;
                        }
                    }
                }
            });
        }
    });
})(jQuery);
